export class Load{
  addonAmount: any;
  address: any;
  amount: any;
  arrivedAtCustomerTime: any;
  b2bInterfaceId: any;
  baseAmount: any;
  billOfLading: string;
  billOfLadingId: any;
  billedGallons: any;
  billingCodeName: any;
  billofLadingSub: any;
  bolendLoadTime: any;
  bolstartLoadTime: any;
  bolstatus: any;
  bolstatus214: any;
  cardnumber: any;
  city: any;
  date: string;
  dealer: any;
  deliveryDate: any;
  demurrageAmount: any;
  eta: any;
  ewindow: any;
  finalizedDeliveryTime: any;
  fname: any;
  holidayAmount: any;
  insuranceSurchargeAmount: any;
  invoiceDate: any;
  irstcn: any;
  latitude: any;
  leftRackTime: any;
  lname: any;
  loadUnderName: any;
  loadedAfterMidnight: any;
  loadingNumber: any;
  locationID: any;
  logon: string;
  longitude: any;
  minimumChargeAmount: any;
  mobilepassword: any;
  netGallons: any;
  orderLine: any;
  pmpumpFee: any;
  priceperGallonforBOL: any;
  productGroupDescription: any;
  productId: number;
  productName: string;
  pumpFee: any;
  punchIn: string;
  punchOut: string;
  quantity: number;
  routeId: number;
  routeStatus: number;
  scac: string;
  scheduleDate: any;
  secondOrderNo: any;
  split: any;
  startTime: any;
  state: any;
  stopOffAmount: any;
  surChargeAmount: any;
  swindow: any;
  tac: any;
  tenant: any;
  terminalName: any;
  terpeningProductID: any;
  tolls: any;
  trailerNumber: any;
  truckNumber: any;
  tstamp: any;
  twoTerminalLoadAmount: any;
}
